module.exports = __webpack_public_path__ + "img/exp1.2012a117.png";